import { FetchState, EmploymentStatus } from "@/shared/types";
import { EmploymentState, UserEmploymentInfo } from "@/employer/types";
import * as userService from "@/shared/api/userService";
import * as storeHelper from "@/shared/storeHelper";
import * as _ from "lodash";
import { defineStore } from "pinia";
import { errorIsStatus } from "@/shared/errorHelper";

const emptyEmploymentInfo: UserEmploymentInfo = {
  employerName: "",
  customEmployerId: "",
  employerSpecifiedId: "",
  employeeIdRef: "",
  dateOfHire: "",
  employmentStatus: EmploymentStatus.None,
  statusEffectiveDate: "",
  terminationDate: "",
  wexEmployerCode: ""
};

const initialState: EmploymentState = {
  employmentInfo: _.cloneDeep(emptyEmploymentInfo),
  fetchState: FetchState.Uninitialized,
  username: ""
};

export const useEmploymentStore = defineStore("employment", {
  state: () => (_.cloneDeep(initialState)),
  getters: {
    isLoading: state => state.fetchState === FetchState.Loading,
    isLoaded: state => state.fetchState === FetchState.Loaded,
    isFailed: state => state.fetchState === FetchState.Failed
  },
  actions: {
    loadEmploymentInfo (args: { username: string, partnerId: number }) {
      if (this.username === args.username) {
        return;
      }

      this.fetchState = FetchState.Loading;

      userService.getUserEmploymentInfo(args)
        .then(response => {
          this.employmentInfo = response.data;
          this.username = args.username;
          this.fetchState = FetchState.Loaded;
        })
        .catch(error => {
          if (errorIsStatus(error, 404)) {
            this.employmentInfo = null;
            this.username = args.username;
            this.fetchState = FetchState.Loaded;
            return;
          }

          this.fetchState = FetchState.Failed;
          return storeHelper.handleError({ error, rethrow: false });
        });
    }
  }
});
